<template>

  <div    >



    <v-text-field
    v-model="pages.q"
    placeholder="Поиск по страницам"


    >
    <v-icon     slot="append"   > mdi-magnify  </v-icon>
    </v-text-field>


 <div  style="font-size:1.2em " >


  <div  v-ripple   v-on:click='selectAll()' class=" meneg_item"><span   v-if=" pages.selector === false ">   Выбрать все </span> <span v-else > Отменить </span> </div>
  <div   v-ripple  v-on:click='copy()' class="meneg_item">Копировать</div>
  <div   v-ripple  v-on:click='toExports()' class="meneg_item" > Экспорт в действия </div>
  <div v-ripple   @click="update()"    class="meneg_item" > Обновить </div>
  <div v-ripple @click="deleteSelected()"  class="meneg_item" > Удалить </div>

  <div style="height:5px"></div>
  <v-divider></v-divider>
  <div v-ripple @click="changeCat()"  class="meneg_item" > Переместить </div>

</div>






  <v-dialog v-model="toExport.dialog" scrollable max-width="300px">
      <v-card>
        <v-card-title> <v-icon medium left style="marginRight:5px"  >mdi-export</v-icon>   Экспорт {{this.pages.selected.length}} в задания</v-card-title>
        <v-divider></v-divider>
        <v-card-text fluid   style="height: 300px;">

          <div  v-if="toExport.loading && toExport.tasksList.length<1" class="text-xs-center">
<v-progress-circular

  :size="70"
  :width="7"
  color="#4A76A8"
  indeterminate
></v-progress-circular>
          </div>

          <div v-for=" item  in this.toExport.tasksList" >
          <v-checkbox v-model="tasks.selected"  v-bind ='[{label:item.name},{value:item.task_id}]'     ></v-checkbox>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A76A8" flat small   @click.native="toExport.dialog = false">Закрыть</v-btn>
          <v-btn v-if='tasks.selected.length>0' :loading="toExport.adding"  :disabled="toExport.adding" color="#4A76A8" small class="white--text"  @click="exportResources()">Выбрать</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>






  <v-dialog v-model="pages.modals.changeCatSelected" scrollable max-width="350px">
      <v-card>

        <v-toolbar flat >
        <v-icon>mdi-checkbox-multiple-marked</v-icon>
        <v-toolbar-title style="color:gray">    Переместить в список</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon style="cursor: pointer" color="#4A76A8" @click.native="pages.modals.changeCatSelected = false" >mdi-close</v-icon>
        </v-toolbar>

        <v-divider></v-divider>
        <v-card-text fluid   style="height: 300px;">
         <v-checkbox @click="lists.newListName = ''" v-model="lists.createNew" label="Переместить в новый список ?"></v-checkbox>
       <v-text-field v-if="lists.createNew"
       v-model="lists.newListName"
       label="Придумайте название нового списка"
       >
       </v-text-field>

       <v-select v-if="!lists.createNew"
       :items="pages.catList" v-model="lists.newListName"
       placeholder="Выберите существующий список"
       >
      <template slot="selection" >
       <span >
        {{lists.newListName}}
       </span>
     </template>

     <template v-slot:item="{ item, attrs, on }">

       <v-list v-bind="attrs">

         <span v-if="item !==pages.selectedCat"  >{{ item }}</span>
         <span style="color:gray" v-else>Текущий список</span>
       </v-list>

     </template>


       </v-select>



        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#4A76A8" flat small   @click.native="pages.modals.changeCatSelected = false">Закрыть</v-btn>
          <v-btn v-if='lists.newListName.length>0 ' :loading="lists.loading"  :disabled="lists.loading" color="#4A76A8" small class="white--text"  @click="changeCatList()">Переместить</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>












  <v-snackbar
    v-model="sb.snackbar"
    :color="sb.color"
    center top


    :timeout="2000"

  >
    {{ sb.text  }}
    <v-btn
      dark
      flat
      @click="sb.snackbar = false"
    >
      ОК
    </v-btn>
  </v-snackbar>




  </div>





</template>




<script>
import axios from 'axios'
 export default {
 props : [ 'pages'  ],
 data(){
   return {
     lists:{
       createNew : false,
       newListName: "",
       loading : false,
       adding: false,


     },

     css: {
       marginTop: "10px"
     },


     tasks:{
       selected:[]
     },
     sb:{
     snackbar: false,
     color: 'success',
     text: ''
   },
    toExport: {
      tasksList:[],
      dialog : false,
      loading: true,
      adding: false,

    }
   }
 },
 methods : {

   changeCat(){
     if(this.pages.selected.length>0){
     this.pages.modals.changeCatSelected = true
   } else {
     this.sb.color = 'error'
     this.sb.text = 'Для перемещения выберите хотя бы одну страницу'
     this.sb.snackbar = true
   }
   },
   changeCatList(){
     this.lists.loading = true
     axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/change_list.php',{
       method: 'POST',
       data: {
         type: 'transfer',
         newListName: this.lists.newListName,
         pgIds: this.pages.selected
       }
     })
     .then( response => {

       this.pages.catList.push(this.lists.newListName)
       this.pages.selectedCat = this.lists.newListName

       axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_get_by_list.php', {
          method: 'POST',
          data : {catList:this.pages.catList, selectedCat:this.pages.selectedCat },
          }).then(response => {
      this.pages.loading = false
      if(response.data.pages){
      this.pages.all = response.data.pages
      this.pages.catList = response.data.catList
      this.pages.selectedCat = response.data.selectedCat
     } else this.pages.all = []
      this.active
      this.pages.beforeDisplayed = this.pages.active

      this.lists.loading = false
      this.pages.modals.changeCatSelected = false
      this.lists.createNew = false
      this.lists.newListName = ""
          })


     })
   },







   update(){

     if(this.pages.selected.length>0){


     this.pages.checker.followers.foundData.selector = false
     this.pages.checker.followers.foundData.foundIds = []
     this.pages.checker.followers.foundData.displayIds = []
     this.pages.checker.followers.foundData.selectedIds = []
     this.pages.checker.followers.foundData.offset = 0

     this.pages.checker.followers_out.foundData.selector = false
     this.pages.checker.followers_out.foundData.foundIds = []
     this.pages.checker.followers_out.foundData.displayIds = []
     this.pages.checker.followers_out.foundData.selectedIds = []
     this.pages.checker.followers_out.foundData.offset = 0

     this.pages.checker.friends.foundData.selector = false
     this.pages.checker.friends.foundData.foundIds = []
     this.pages.checker.friends.foundData.displayIds = []
     this.pages.checker.friends.foundData.selectedIds = []
     this.pages.checker.friends.foundData.offset = 0

     this.pages.checker.friends_out.foundData.selector = false
     this.pages.checker.friends_out.foundData.foundIds = []
     this.pages.checker.friends_out.foundData.displayIds = []
     this.pages.checker.friends_out.foundData.selectedIds = []
     this.pages.checker.friends_out.foundData.offset = 0

   this.pages.selected.forEach( (item, i, arr)=>{
     this.pages.checkList.push(item.id)
   })
     this.pages.selected = []
     this.pages.beforeDisplayed.forEach(function(item, i, arr){
       item.add_info.selected = false
     })

     this.pages.modals.checkPages = true
   } else {
     this.sb.color = 'error'
     this.sb.text = 'Для обновления выберите хотя бы одну страницу'
     this.sb.snackbar = true
   }
   },
   deleteSelected: function(){
     if(this.pages.selected.length>0){
     this.pages.modals.deleteSelected = true
   } else {
     this.sb.color = 'error'
     this.sb.text = 'Выберите одну или несколько страниц'
     this.sb.snackbar = true
   }
   },
   selectAll: function(){

     if(this.pages.selector ===  true){

       this.pages.selected = []
       this.pages.selector = false
       this.pages.beforeDisplayed.forEach(function(item, i, arr){
         item.add_info.selected = false
       })

     }
     else {
       this.pages.beforeDisplayed.forEach(function(item, i, arr){
         item.add_info.selected = true
       })
       this.pages.selected = []
       this.pages.selected =  this.pages.selected.concat(this.pages.beforeDisplayed)
       this.pages.selector = true
     }

   },
   copy: function(){

      if(this.pages.selected.length>0){
        console.log(this.pages.selected)
    let data = []
    this.pages.selected.forEach(function(item, i, arr){
      data.push(item.vk_id)
    })


     navigator.clipboard.writeText(data.join(','))
     .then ( ()=>{
       this.sb.color = 'success'
       this.sb.text = 'Скопированно '+this.pages.selected.length
       this.sb.snackbar = true
     }
      )
} else {
  this.sb.color = 'error'
  this.sb.text = 'Выберите хотябы один элемент'
  this.sb.snackbar = true
}


   },

toExports: function(){

  if(this.pages.selected.length>0){
   this.toExport.dialog = true
   this.toExport.loading = true
   axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
        method: 'POST',
        data: {
          contentType: 'pages'
        }
      })
      .then( response => {
        this.toExport.loading = false
        console.log(response.data)
        this.toExport.tasksList = response.data

      })
} else {
this.sb.color = 'error'
this.sb.text = 'Выберите хотябы один элемент'
this.sb.snackbar = true
}
},
exportResources: function(){
  let datas = []
  this.pages.selected.forEach(function(item, i, arr){
    datas.push(item.vk_id)
  })
     this.toExport.adding = true
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
       method: 'POST',
       data: {
       taskIds: this.tasks.selected,
       data: datas
       }
     })
     .then( response => {
       console.log(response.data)
       this.toExport.adding = false
       this.toExport.dialog = false
       this.tasks.selected = []
       this.sb.color = 'success'
       this.sb.text = 'Успешный экспорт '+this.pages.selected.length
       this.sb.snackbar = true

     })
}



},
computed: {

}
 }
</script>
